#popover-tag {
  --offset-y: -10px; 
  --offset-x: -150px; 
}

#popover-tag::part(content) {
  left: 0 !important;
  top: 0 !important;
  transform: translate(-100%, -100%) !important; 
}